/* eslint-disable import/prefer-default-export */
import { RentSplit } from '../../../../services/remoteSigning/payment/Payment';

export const sortPrimary = (split: RentSplit[]): RentSplit[] => {
  const primary = split.filter((s) => s.userType === 'PRIMARY');
  const notPrimary = split.filter((s) => s.userType !== 'PRIMARY');
  return primary.concat(notPrimary);
};
